<template>
    <div id="contacts">
        <div class="tabulation-title mb-4">
            <h5>
                <v-icon color="primary">label_outline</v-icon> Moyens de communication
            </h5>
        </div>

        <div class="mr-auto ml-auto">
            <div v-for="communication in provider.communications" class="type-com mb-5">
                <div class="tabulation-title mb-5">
                    <h5 style="font-size: 15px" class="d-flex">
                        <v-icon color="primary">{{ getContactIcon(communication.type.name) }}</v-icon>
                        <div class="mt-auto mb-auto ml-2">{{ communication.type.label }}</div>
                    </h5>
                </div>

                <div>
                    <v-text-field v-model="communication.value" outlined>
                    </v-text-field>
                </div>

                <div class="mt-5" v-if="communication.type.name === 'EMAIL' && communication.value === null">
                    <v-alert type="warning">
                        <div>
                            <span>Nos robots n'ont pas pu récupérer l'adresse email sur </span>
                            <b>
                                <span v-if="fbPageUrl !== null && tripPageUrl !== null">Facebook et Tripadvisor</span>
                                <span v-else-if="fbPageUrl !== null">Facebook</span>
                                <span v-else-if="tripPageUrl !== null">Tripadvisor</span>
                            </b>.
                        </div>
                        <br>
                        <div>
                            Néanmoins, il est possible qu'une adresse e-mail soit présente sur leur page.
                            Nous vous conseillons de le vérifier manuellement au travers des liens ci-dessous.
                            Si un e-mail est présent, vous pourrez ensuite le reporter dans le champ E-mail.
                        </div>
                        <br>
                        <div class="d-flex">
                            <div v-if="fbPageUrl !== null">
                                <v-btn color="primary" class="ml-2" target="_blank" :href="fbPageUrl">
                                    <span style="color: white">Page Facebook</span>
                                    <v-icon class="ml-2" style="color: white">open_in_new</v-icon>
                                </v-btn>
                            </div>
                            <div v-if="tripPageUrl !== null">
                                <v-btn color="primary" class="ml-2" target="_blank" :href="tripPageUrl">
                                    <span style="color: white">Page Tripadvisor</span>
                                    <v-icon class="ml-2" style="color: white">open_in_new</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Communication",
    props: ["provider", "fbPageUrl", "tripPageUrl"],
    methods: {
        getContactIcon(name) {
            let icon = null

            switch (name) {
                case 'EMAIL':
                    icon = 'email'
                    break
                case 'PHONE':
                case 'FAX':
                    icon = 'phone'
                    break
                default:
                    icon = 'language'
            }

            return icon
        }
    }
}
</script>